import gql from 'graphql-tag';

export const GET_INDUSTRIES = gql`
  query Industries($name: String) {
    industries(name: $name) {
      id
      name
    }
  }
`;
